import { cn } from 'cn';
import { type PropsWithChildren, type ReactNode } from 'react';

type P = PropsWithChildren<{
  readonly icon: ReactNode;
  readonly onClick: () => void;
}> &
  ComponentStyling;

export const ListItem = ({ children, className, icon, onClick, style }: P) => (
  <div
    className={cn(
      'group flex h-full w-full cursor-pointer items-center gap-2 truncate px-4 py-1 hover:bg-tiga-surface-off-white',
      className,
    )}
    style={style}
    onMouseDown={onClick}
  >
    <div className="flex-1 truncate">{children}</div>
    {Boolean(icon) && (
      <div className="shrink-0 text-tiga-text-lighter group-hover:text-tiga-action-lighter">
        {icon}
      </div>
    )}
  </div>
);
